/*
 * Unpoly comes first: it sets window.up, which wwwroot/js scripts and the page entries use. The layout's
 * <html up-boot="manual"> stops it from booting until unpolyEvents.js calls up.boot().
 */
import "unpoly";
import "unpoly/unpoly.css";

/*
 * Unlike webpacker, vite does not include the CSS files in the JS file.
 * This simply tells vite to build them.
 */
import "../Stylesheets/site.css";
import "../Stylesheets/kendo.scss";

import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

initializeFaro({
    url: 'https://faro-collector-prod-us-central-7.grafana.net/collect/3d26664c2f4e1a429cdf9dcb48a63247',
    app: {
        name: 'Greenix Utilities',
        version: '1.0.0',
        environment: 'production'
    },
    sessionTracking: {
        samplingRate: 1,
        persistent: true
    },
    instrumentations: [
        // Mandatory, omits default instrumentations otherwise.
        ...getWebInstrumentations(),

        // Tracing package to get end-to-end visibility for HTTP requests.
        new TracingInstrumentation(),
    ],
});
